import React from "react";

import Badge from "antd/es/badge";
import { useIntl } from "react-intl";

interface Props {
  matched: boolean;
}

const MatchedInformation: React.FC<Props> = ({ matched }) => {
  const intl = useIntl();
  return (
    <Badge
      status={matched ? "success" : "default"}
      text={intl.formatMessage(
        {
          id: "matchInformation.label",
          defaultMessage: "{matched, select, true {Matched} other {Not matched}}",
          description: "Text of Match status",
        },
        { matched }
      )}
    />
  );
};

export default MatchedInformation;
